module.exports = __webpack_public_path__ + "img/1-map-c@2x.11aa65b7.png";